import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-sante-particuliers',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-sante-particuliers.component.html',
  styleUrl: './assurance-sante-particuliers.component.scss'
})
export class AssuranceSanteParticuliersComponent implements OnInit {
  title = 'Assurance Mutuelle Santé Individuelle';
  subtitle = 'Protection santé complète pour vous et votre famille';
  phoneNumber = '07 82 28 11 16';
  heroVideo = 'assets/videos/sante.mp4';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Santé', link: undefined }
  ];

  prevPage = undefined;
  nextPage = { 
    title: 'Assurance Prévoyance Particuliers',
    link: '/assurance-mutuelle-sante-internationale'
  };

  // Partner logos
  partners = [
    { name: 'GENERALI', logo: 'assets/images/logos/generali-logo.png' },
    { name: 'APRIL', logo: 'assets/images/logos/april-logo.png' },
    { name: 'SWISSLIFE', logo: 'assets/images/logos/swisslife-logo.png' },
    { name: 'CARDIF', logo: 'assets/images/logos/cardif-logo.png' },
    { name: 'NEOLIANE', logo: 'assets/images/logos/neoliane-logo.png' },
    { name: 'UTWIN', logo: 'assets/images/logos/utwin-logo.png' },
    { name: 'APIVIA', logo: 'assets/logos/APIVIA.png' }
  ];

  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }

  navigateToDevis(): void {
    this.router.navigate(['/devis']);
  }
}

